export function isNotNull<T>(arg: T | null): arg is T {
  return arg !== null;
}

export function isNotNullable<T>(arg: T | null | undefined): arg is T {
  return arg !== null && arg !== undefined;
}
